import { Button } from "components/Button";
import { TQuiz } from "types/quiz";
import { learnService } from "../service";
import { useState } from "react";

type TProps = {
  quiz: TQuiz;
};

export const QuizRow = ({ quiz }: TProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const onDelete = async () => {
    try {
      setIsDeleting(true);
      await learnService.deleteQuiz(quiz.id);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this quiz?')) {
      onDelete();
    }
  };

  return (
    <tr className="text-nowrap divide-x divide-[#05050550]">
      <td className="p-2 px-4 text-center">
        {quiz.name}
      </td>

      <td className="p-2 px-4 text-center">
        {quiz.reward}
      </td>

      <td className="p-2 px-4 text-center">
        {quiz.questions.length}
      </td>

      <td className="flex-1 p-2 px-4 text-center gap-2 flex justify-center">
        <Button
          extraClass="h-[28px] py-0 px-2 w-fit" 
          // onClick={onApprove}
          // disabled={isOnApprove}
          disabled
        >
          Edit
        </Button>

        <Button
          extraClass="h-[28px] py-0 px-2 w-fit bg-[#DB5024]" 
          onClick={handleDelete}
          disabled={isDeleting}
        >
          Delete
        </Button>
      </td>
    </tr>
  );
};
